export interface ICollectionApiResponse {
  collectionName: string;
  data: {
    items: ICollectionItem[];
    itemsCount: number;
    totalCount: number;
    isEmpty: boolean;
  };
}

export interface ICollectionItem {
  id: number;
  type: string;
  title: string;
  summary: string;
  thumbnail: Thumbnail | null;
  publishDate: string;
  tagGroups: TagGroup[] | null;
}

export interface Thumbnail {
  sourceUrl: string;
  uid: string;
  fileName: string;
  extension: string;
  mimeType: string;
  size: number;
}

export interface TagGroup {
  id: number;
  name: string;
  color: string;
  relatedItemsCount: number;
  franchiseLocalization: string;
  localizationGroupId: number;
  localizations: any[]; // Если структура localizations известна — задай тип, сейчас оставил как any[]
}


export enum E_COLLECTION_FOLDER_TYPES {
  News = 'News',
  Publication = 'Publication',
  Meeting = 'Meeting',
  Discussion = 'Discussion',
  Standards = 'Standard',
  Project = 'Project',
  Jurisdiction = 'Jurisdiction',
  Resource = 'Resource',
  ImportantDates = 'ImportantDates',
}

export enum ESortDirection {
  Asc = 1,
  Desc = 2
}
